// API Configuration
export const API_CONFIG = {
  // Replace this with your actual Lambda invoke URL
  BASE_URL: 'https://hg9ykqmu3m.execute-api.us-west-2.amazonaws.com/prod',
  
  // API Endpoints
  ENDPOINTS: {
    EVENTS: '/events',
    SEATING: '/seating',
    VERSIONS: '/versions'
  }
};

// AWS Configuration
export const AWS_CONFIG = {
  REGION: 'us-west-2',
  COGNITO_USER_POOL_ID: 'us-west-2_TSOy7pu6R',
  COGNITO_CLIENT_ID: 'tcsoi579h296leirckhdocjqr',
  IDENTITY_POOL_ID: 'us-west-2:c9abf28d-8a06-4140-a9f1-284b85791c30'
};

// DynamoDB Table Names
export const TABLE_NAMES = {
  WEDDING_EVENTS: 'wedding_events',
  WEDDING_SEATING: 'erikaandrew_wedding_seating',
  WEDDING_RSVP: 'erikaandrew_wedding'
}; 